"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transfer_param_1 = require("./transfer-param");
var xtransfer_target_1 = require("./xtransfer-target");
var XTransferOperation = /** @class */ (function () {
    function XTransferOperation(source, target, hops) {
        this.source = source;
        this.target = target;
        this.hops = hops;
    }
    XTransferOperation.from = function (rawTransfer) {
        var rawSource = rawTransfer.args[0];
        var source = new transfer_param_1.default(rawSource[0], rawSource[1], rawSource[3]);
        var target = new xtransfer_target_1.default(rawTransfer.args[1][0]);
        var hops = rawTransfer.args[2];
        return new XTransferOperation(source, target, hops);
    };
    return XTransferOperation;
}());
exports.default = XTransferOperation;
//# sourceMappingURL=xtransfer-operation.js.map